import { cn } from '@/lib/utils';

interface ImageSectionProps {
  content: {
    imageUrl?: string;
    alt?: string;
    caption?: string;
    fullWidth?: boolean;
  };
  variant?: string;
  layoutStyle?: string;
}

export function ImageSection({ content, variant = 'default', layoutStyle = 'classic' }: ImageSectionProps) {
  const {
    imageUrl,
    alt = '',
    caption,
    fullWidth = false,
  } = content;

  const isMinimal = layoutStyle === 'modern-minimal';
  const isPlayful = layoutStyle === 'playful-rounded';

  if (!imageUrl) {
    return (
      <section className="section-padding bg-muted/30">
        <div className="container mx-auto px-4">
          <div className="aspect-video bg-muted rounded-xl flex items-center justify-center">
            <p className="text-muted-foreground">No image set</p>
          </div>
        </div>
      </section>
    );
  }

  if (fullWidth || variant === 'fullwidth') {
    return (
      <section className="relative">
        <img 
          src={imageUrl} 
          alt={alt} 
          className="w-full h-auto max-h-[80vh] object-cover"
        />
        {caption && (
          <p className="text-center text-sm text-muted-foreground py-4 bg-background">
            {caption}
          </p>
        )}
      </section>
    );
  }

  return (
    <section className="section-padding bg-background">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto">
          <img 
            src={imageUrl} 
            alt={alt} 
            className={cn(
              "w-full h-auto shadow-lg",
              isMinimal ? "rounded-none" : isPlayful ? "rounded-[2rem]" : "rounded-2xl"
            )}
          />
          {caption && (
            <p className="text-center text-sm text-muted-foreground mt-4">
              {caption}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}